$(function () {
    var $news = $('#newsScrollContainer ul').flickity({
        autoPlay: 5000,
        cellAlign: 'left',
        contain: false,
        draggable: false,
        pageDots: false,
        pauseAutoPlayOnHover: false,
        on: {
            ready: function () {
                // Add pause button
                var pause = '<button class="flickity-button pause" type="button" aria-label="Pause alert carousel" aria-selected="false"></button>';

                $(pause).insertAfter('.flickity-prev-next-button.previous');

                $('#newsScrollContainer .flickity-button').detach().appendTo('.ticker-content-controls');
            }
        }
    });

    $news.flickity('resize');
});
